jQuery(document).ready(function () {

    if ($('.dnChartDatePicker').length) {

        var daterangepickerLocale = {
            "format": translationTo.dateFormat,
            "separator": " - ",
            "applyLabel": translationTo.applyLabel,
            "cancelLabel": translationTo.cancelLabel,
            "fromLabel": translationTo.fromLabel,
            "toLabel": translationTo.toLabel,
            "customRangeLabel": translationTo.customRangeLabel,
            "weekLabel": "W",
            "daysOfWeek": [
                translationTo.daysOfWeekSu,
                translationTo.daysOfWeekMo,
                translationTo.daysOfWeekTu,
                translationTo.daysOfWeekWe,
                translationTo.daysOfWeekTh,
                translationTo.daysOfWeekFr,
                translationTo.daysOfWeekSa,
                translationTo.daysOfWeekSu
            ],
            "monthNames": [
                translationTo.monthNameJanuary,
                translationTo.monthNameFebruary,
                translationTo.monthNameMarch,
                translationTo.monthNameApril,
                translationTo.monthNameMay,
                translationTo.monthNameJune,
                translationTo.monthNameJuly,
                translationTo.monthNameAugust,
                translationTo.monthNameSeptember,
                translationTo.monthNameOctober,
                translationTo.monthNameNovember,
                translationTo.monthNameDecember
            ],
            "firstDay": 1
        };

        var refreshSelector = function (elRange, start, end) {
            elRange.html(start.format(translationTo.dateFormat) + ' - ' + end.format(translationTo.dateFormat));
        };

        var refresh = function (url, elRange, start, end) {
            refreshSelector(elRange, start, end);

            var chartJsId = elRange.closest('.dnChartDatePicker-container').find('canvas').first().attr('id');

            var chart = getChartJsById(chartJsId);

            $.ajax({
                type: "POST",
                url: url,
                data: {dateFrom: start.format('YYYY-MM-DD'), dateTo: end.format('YYYY-MM-DD')},
                success: function (ret) {
                    updateChartJsChart(chart, ret.labels, ret.valueLabels, ret.values);
                }
            });
        };

        $('.dnChartDatePicker').each(function () {
            var elRange = $(this).find('span');

            var start = moment($(this).data('dateFrom'));
            var end = moment($(this).data('dateTo'));

            var dateRanges = [];

            dateRanges[translationTo.last30DaysLabel] = [moment(end).subtract(29, 'days'), end];

            if ($(this).data('dateSalesStart')) {
                var salesStart = moment($(this).data('dateSalesStart'));
                dateRanges[translationTo.wholeSalesRange] = [salesStart, end];
            }

            if (typeof $(this).data('withTrendRange') !== 'undefined') {
                var salesStart = moment($(this).data('dateSalesStart'));
                var salesEnd = moment($(this).data('dateSalesEnd'));
                dateRanges[translationTo.trendlineLabel] = [salesStart, salesEnd, '?with-trend=1'];
            }

            $(this).daterangepicker({
                startDate: start,
                endDate: end,
                locale: daterangepickerLocale,
                ranges: dateRanges,
                opens: 'left',
                showDropdowns: true
            });

            refreshSelector(elRange, start, end);

            $(this).on('apply.daterangepicker', function (ev, picker) {
                var url = $(this).data('refreshUrl');

                if (dateRanges[picker.chosenLabel] !== undefined && dateRanges[picker.chosenLabel][2] !== undefined) {
                    url = url + dateRanges[picker.chosenLabel][2];
                }

                refresh(url, elRange, picker.startDate, picker.endDate);
            });

        });
    }
});